/**
 * DevExtreme (esm/__internal/ui/list/modules/m_search.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import TextBox from "../../../../ui/text_box";
import searchBoxMixin from "../../../../ui/widget/ui.search_box_mixin";
searchBoxMixin.setEditorClass(TextBox);
